import { useContext, useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import css from "./DropdownSection.module.css";

import Section from "./section";

function DropdownSection(props) {
  const [showRules, setShowRules] = useState(false);

  function onClick() {
    setShowRules(!showRules);
    console.log(showRules);
  }

  return (
    <Section>
      <div className={css.titleContainer} onClick={onClick}>
        <h1 className={css.h1}>{props.title}</h1>
        <IoIosArrowUp
          size={35}
          className={`${css.arrow} ${
            showRules ? css.rotateDown : css.rotateUp
          }`}
        />
      </div>
      <div
        className={`${css.dropdownContentContainer} ${
          showRules ? css.slideFromTopToTop : css.slideFromTopToBottom
        }`}
      >
        {props.children}
      </div>
    </Section>
  );
}

export default DropdownSection;
